module.exports = __webpack_public_path__ + "img/20_21.a31c8948.png";